/**
 * Centralized Logging Exports
 * Single import point for all logging functionality
 */

export { logger, LogLevel } from './logger';
export type { LogContext } from './logger';

export {
  authLogger,
  operationsLogger,
  componentLogger,
  systemLogger,
  performanceLogger,
  dbLogger
} from './specialized';

// Import the logger instance for convenience exports
import { logger } from './logger';

// Convenience re-exports for common patterns
export const log = {
  error: logger.error.bind(logger),
  warn: logger.warn.bind(logger),
  info: logger.info.bind(logger),
  debug: logger.debug.bind(logger),
  time: logger.time.bind(logger)
};